import { IconButton } from "../../../../Buttons/IconButton";
import { ShipCard } from "../../../../Cards/ShipCard";
import { FormLabel } from "../../../FormLabel";
import { CustomsInvoiceRowForm } from "./CustomsInvoiceRowForm";
import { HiMiniDocumentPlus } from "react-icons/hi2";
import { Label } from "./Label";
import CustomsInvoiceAlert from "../../../../Alerts/CustomsInvoiceAlert";
import { CURRENCIES } from "../../../../../data/currencies";
import { Select } from "../../../Select";

const LABELS = [
  { label: "Description", colSpan: 8 },
  { label: "HS / HST Code", colSpan: 6 },
  { label: "Origin Country", colSpan: 4 },
  { label: "Unit Price", colSpan: 2 },
  { label: "Qty", colSpan: 1 },
];

const LabelRow = () => (
  <div className="grid grid-cols-1 sm:grid-cols-24 mt-2 mb-2">
    {LABELS.map(({ label, colSpan }) => (
      <div key={label} className={`col-span-${colSpan}`}>
        <Label label={label} />
      </div>
    ))}
  </div>
);

export function CustomsInvoiceForm({
  setValue,
  watch,
  control,
  fields,
  append,
  remove,
}) {
  return (
    <ShipCard>
      <div className="z-10">
        <div className="mb-5">
          <CustomsInvoiceAlert />
        </div>
        <div className="flex flex-row justify-between items-center w-full">
          <div className="sm:col-span-3 mr-10 self-start">
            <FormLabel title="Invoice" />
          </div>
          <IconButton
            icon={<HiMiniDocumentPlus className="text-gray-500" />}
            onClick={append}
          />
        </div>

        <div className="flex justify-start mb-5">
          <div className="w-full max-w-[220px]">
            <Select
              label="Currency"
              name="invoiceCurrency"
              options={CURRENCIES}
              control={control}
              placeholder="Select a currency"
            />
          </div>
        </div>

        <div>
          <LabelRow />
          {fields.map((item, index) => (
            <div
              key={item.id}
              className={index !== fields.length - 1 ? "pb-3" : ""}
            >
              <CustomsInvoiceRowForm
                control={control}
                index={index}
                remove={remove}
                watch={watch}
                setValue={setValue}
              />
            </div>
          ))}
        </div>
      </div>
    </ShipCard>
  );
}
